// © Microsoft Corporation. All rights reserved.

/**
 * Since it's not decided if the abbreviation should be localized,
 * we keep the abbreviations as "k" and "M" for now.
 */
const millionAbbrev = "1M";
const moreThanMillionAbbrev = "1M+";
const thousandsAbbrev = "k";

/**
 * Helper function that formats number to be shown more readable using abbreviations (e.g. "k" for thousands)
 * @param count - number of comments to be formatted into easily readable string
 * @returns {string | number} the count of comments
 */
export function abbreviateNumber(count: number): string | number {
    if (count === undefined || count < 1) {
        return;
    } else if (count < 1000) {
        return count;
    } else if (count > 999499 && count <= 1000000) {
        return millionAbbrev;
    } else if (count > 1000000) {
        return moreThanMillionAbbrev;
    }

    // if number of digits would be 1 after using abbreviation ("k"), 1 decimal is allowed
    const numDigits = Math.log(count) * Math.LOG10E + 1 | 0;
    const decimalLength = numDigits % 3 === 1 ? 1 : 0;
    return roundWithPrecision(count/1000, decimalLength) + thousandsAbbrev;
}

/**
 * Helper function that rounds a number to have certain number of decimals
 * @param num - a number that has decimals to be rounded with precision
 * @param precision - a number of decimals that should be kept after rounding
 */
function roundWithPrecision(num: number, precision: number): number {
    const prec = Math.pow(10, precision);
    return Math.round(num * prec)/prec;
}